$(function(){
  init();

  function init() {
    var $form = $('#form');
    $form.submit(function () {
      $.ajax({
        url: $form.attr('action'),
        data: $form.serialize(),
        type: 'POST',
        dataType: 'json',
        success: function(json) {
          var status = json.status;
          if (status === 'success') {
            $('#message').html('<div class="c-panel"><div class="c-panel-contents"><p class="u-align-center">お問い合わせありがとうございます。</p><p class="u-align-center">お客様からのお問い合わせ内容を確認のうえ、<br>後日弊社担当者からご連絡させていただきます。<br>ご連絡があるまでしばらくお待ちください。<br>なお、弊社からのご連絡がなかなか来ない場合は、<br>下記番号までご連絡いただけますと幸いです。</p><p class="u-align-center">グローバル住販人形町仲介センター<br>TEL：0120-602-968<br>営業時間／〈平日〉　11：30～18：00<br> 〈土日祝〉10：00～18：00<br>定休日 毎週火・水曜日</p></div></div>');
            $form.addClass('completion');
          } else if (status === 'failed') {
            $('#message').html('<div class="c-panel"><div class="c-panel-contents"><p class="u-align-center">お問い合わせの受付に失敗しました。メールアドレスに間違いがないかご確認ください。</p></div></div>');
          } else {
            var errors = json.err_msg;
            var msg = '';
            for (var i = 0; i < errors.length; i++) {
              msg += '<li>' + errors[i] + '</li>';
            }
            $('#message').html('<div class="c-panel c-panel--border"><div class="c-panel-contents"><ul class="c-list c-list--error">' + msg + '</ul></div></div>');
          }
        }
      });
      return false;
    });
  }
});

$(function() {
    $('#form').find('textarea, :text, radio').val('').end().find(':checked').prop('checked', false);
});